// extracted by css-extract-rspack-plugin
export default {"tzBox":"index__tzBox___zzG8m"};